export type GlobalDialogState = {
  openDialogs: {
    [key: string]: {
      context: any;
    };
  };
};
type State = { globalDialogs: GlobalDialogState };

export const openGlobalDialogsSelector = (state: State) => state.globalDialogs.openDialogs;
